import { LoadingCase } from '../loading-case.model';
import { AnalysisEnvironmentLoad } from './analysis-environment-load';
import { AnalysisPostProcessing } from './analysis-post-processing';
import { AssemblyMovement } from './assembly-movement.model';
import { AssemblyConfiguration } from './configurations/assembly-configuration.model';
import { DynamicConfiguration } from './configurations/dynamic-configuration.model';
import { StaticConfiguration } from './configurations/static-configuration.model';
import { FluidFunction } from './fluid-function.model';
import { LimitState } from './limit-state.enum';
import { MovementTransferType } from './movement-transfer-type';
import { SolverType } from './solver-type';

export class AnalysisCase {
  id: number;
  title: string;
  internalId: number;
  staticSimulation: boolean;
  dynamicSimulation: boolean;
  assemblySimulation: boolean;
  limitStateType: LimitState;
  movementTransferType: MovementTransferType;
  solverType: SolverType;
  staticConfiguration: StaticConfiguration;
  dynamicConfiguration: DynamicConfiguration;
  assemblyConfiguration: AssemblyConfiguration;
  loadingCase: LoadingCase[];
  movementsAssembly: AssemblyMovement[];
  fluidFunction: FluidFunction[];
  environmentLoad: AnalysisEnvironmentLoad;
  postProcessing: AnalysisPostProcessing[];

  constructor() {}
}
